import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontSizes, lineHeights, fontWeights,
}: Theme) => ({
  paper: {
    '&&': {
      width: '20.5rem',
      maxWidth: '100%',
      borderRadius: '0.5rem',
      paddingTop: '2rem',
      paddingBottom: '2rem',
      [breakpoints.up('md')]: {
        width: '31.25rem',
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    [breakpoints.up('md')]: {
      gap: '2rem',
    },
    '&&': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  title: {
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
  },
  description: {
    margin: 0,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
}));
